export enum EIconReceiptType {
    IDENTITY_CARD = "IdentityCard",
    CARD ='IBAN',
    ADDRESS_PROOF = "AddressProof",
    OTHER = "other",

    UPLOAD = "upload",
    DOWNLOAD = "download",
    EYE = "eye",
    CROSS = "cross",
    ARROW_DOWN = "arrowDown",
}